import React, { useState, useEffect } from "react";
import FileManagerDropdown from "../../../../components/partials/file-manager-dropdown/FileManagerDropdown";
import moment from "moment";
import filemedia from "../../../../images/icons/file-media.svg";
import { useCookies } from "react-cookie";
import { Modal } from "reactstrap";
import { Icon } from "components/Component";

const Grid = ({ data, setData }) => {
  const [cookies] = useCookies(["user"]);
  const [showImage, setShowImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const [filterSelect] = useState("Last Opened");
  const [dataList, setDataList] = useState();

  const isPicture = (extension) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico', 'tiff', 'tif'];
    return imageExtensions.includes(extension.toLowerCase());
  };

  useEffect(() => {
    if (data.length > 0) {
      let filteredData = data.filter((item) => Boolean(item.recovery) === false);
      setDataList([...filteredData]);
    } else {
      setDataList([]);
    }
  }, [data]);

  useEffect(() => {
    if (dataList) {
      let defaultData = dataList;
      if (filterSelect === "Name") {
        defaultData.sort(function (a, b) {
          if (a.meta.name.toUpperCase() < b.meta.name.toUpperCase()) {
            return -1;
          }
          if (a.meta.name.toUpperCase() > b.meta.name.toUpperCase()) {
            return 1;
          }
          return 0;
        });
        setDataList([...defaultData]);
      } else if (filterSelect === "Size") {
        defaultData.sort(function (a, b) {
          if (a.meta.size < b.meta.size) {
            return -1;
          }
          if (a.meta.size > b.meta.size) {
            return 1;
          }
          return 0;
        });
        setDataList([...defaultData]);
      } else {
        let filteredData = data.filter((item) => !item.recovery);
        setDataList([...filteredData]);
      }
    }
  }, [filterSelect]); // eslint-disable-line react-hooks/exhaustive-deps

  // Usage in your component:

  return (
    <div className="nk-files nk-files-view-grid">
      {dataList && dataList.length > 0 ? (
        <React.Fragment>
          <div className="nk-files-head">
            <div className="nk-file-item">
              <div className="nk-file-info"></div>
            </div>
          </div>
          <div className="nk-files-list">
            {dataList.map((item) => (
              <div className="nk-file-item nk-file" key={item.id}>
                <div className="nk-file-info">
                  <div className="nk-file-title">
                    <div className="nk-file-icon">
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={(ev) => {
                        ev.preventDefault();
                        // downloadFile(item);
                      }}
                      className="nk-file-icon-link"
                      rel="noopener noreferrer"
                    >
                      <span 
                        className="nk-file-icon-type"
                        style={{
                          display: 'block',
                          height: '100px', // Set your desired height
                          width: '100%',
                          overflow: 'hidden'
                        }}
                      >
                        <img 
                          alt=""
                          data-file-id={item.id}
                          onClick={()=>{
                            if(isPicture(item.extension)){
                              setShowImage(true);
                              setSelectedImage(process.env.REACT_APP_S3_URL + item.link);
                            }
                          }}
                          src={isPicture(item.extension) ? process.env.REACT_APP_S3_URL + item.link : filemedia}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain', // or 'contain' depending on your preference
                            objectPosition: 'center'
                          }}
                        />
                      </span>
                    </div>
                    </div>
                    <div className="nk-file-name">
                      <div className="nk-file-name-text">
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={(ev) => {
                            ev.preventDefault();
                            // downloadFile(item);
                          }}
                          rel="noopener noreferrer"
                          className="title"
                        >
                          {item.name}
                        </div>
                      </div>
                    </div>
                  </div>
                  <ul className="nk-file-desc">
                    <li className="date">{moment(item.updatedAt).format("MMM DD, YYYY, HH:mm")}</li>
                    <li className="size">{parseInt(item.size / 1000)} KB</li>
                  </ul>
                  {/* <Icon name={'copy'} onClick={()=>handleCopyFile(item)}/> */}
                </div>
                <FileManagerDropdown cookies={cookies} file={item} />
              </div>
            ))}
          </div>
          <Modal isOpen={showImage} toggle={() => setShowImage(false)} size="large">
            <div className="button-bar">
              <div
                className="d-flex flex-row justify-content-end p-1"
                style={{ position: "relative", width: "100vw", background: "rgba(0, 0, 0, 0.44)" }}
              >
                <a href="#close" onClick={(ev) => { ev.preventDefault(); setShowImage(false); }} className="mr-2">
                  <Icon name="cross" className="icon-image-download" />
                </a>
              </div>
            </div>
            <img className="rounded" src={selectedImage} style={{ height: "100%" }} alt={selectedImage} />
          </Modal>
        </React.Fragment>
      ) : (
        <div>No folders or files are available</div>
      )}
    </div>
    
  );
};

export default Grid;
